import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { LangProvider } from './context/LangContext';
import './index.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // StrictMode temporarily disabled to prevent double API calls in development
  // <React.StrictMode>
    <LangProvider>
      <App />
    </LangProvider>
  // </React.StrictMode>
);